import React, { useState } from 'react';
import { FaStar } from "react-icons/fa";
import { useNavigate } from 'react-router-dom';

const FALLBACK_IMAGE = 'https://via.placeholder.com/400x300?text=No+Image';

const ProductCard = ({ _id, name, image, price, rating, numReviews, countInStock }) => {
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  return (
    <div className="w-full bg-white shadow-md border border-gray-100 rounded-lg overflow-hidden hover:shadow-lg transition-shadow">

      {/* بخش تصویر - ارتفاع ثابت */}
      <div className="w-full h-[165px] bg-gray-100 overflow-hidden">
        <img
          src={imageError ? FALLBACK_IMAGE : (image || FALLBACK_IMAGE)}
          alt={name || 'محصول'}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
          onError={() => setImageError(true)}
          loading="lazy"
        />
      </div>

      {/* محتوا */}
      <div className="text-center py-2 px-2">
        <h3 className="text-sm font-bold text-gray-800 px-1 truncate">
          {name || 'بدون نام'}
        </h3>

        {/* امتیازدهی */}
        <div className="flex justify-center items-center gap-0.5 mt-1">
          {Array.from({ length: 5 }).map((_, index) => (
            <FaStar
              key={index}
              size={13}
              className={index < (rating || 0) ? "text-yellow-400" : "text-gray-300"}
            />
          ))}
          <span className="text-[10px] text-gray-400 mr-1">({numReviews || 0})</span>
        </div>

        {/* قیمت */}
        <p className="mt-1 text-sm font-bold" style={{ color: '#9EAD8C' }}>
          {Math.round(price || 0).toLocaleString()} تومان
        </p>

        {/* دکمه */}
        <button
          onClick={() => navigate(`/product/${_id}`)}
          className="mb-1.5 w-[90%] rounded-[5px] text-white py-2.5 text-sm transition-all duration-300 hover:opacity-80"
          style={{ backgroundColor: '#8B7355' }}
        >
          جزئیات محصول
        </button>
      </div>
    </div>
  );
};

export default ProductCard;